import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    container: {
        width: "100%",
        alignItems: "center",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            maxWidth: 378,
            paddingBottom: theme.spacing(5),
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            alignItems: "flex-start",
            maxWidth: undefined,
        },
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    subtitle: {
        marginBottom: theme.spacing(3),
        textAlign: "center",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            textAlign: "start",
        },
    },
    commentHighlight: {
        fontWeight: theme.typography.fontWeightRegular,
    },
    priceContainer: {
        marginBottom: theme.spacing(3),
    },
    firstUsage: {
        alignItems: "center",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            gap: theme.spacing(2),
        },
    },
    firstUsageDescription: {
        fontWeight: theme.typography.fontWeightLight,
        fontSize: 24,
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            fontSize: 20,
        },
    },
    list: {
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(3),
        justifyContent: "flex-start",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            width: 387,
        },
    },
    listItem: {
        alignItems: "center",
        minHeight: theme.spacing(4),
        gap: theme.spacing(1),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            gap: theme.spacing(2),
        },
    },
    ctaGroup: {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(3),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            width: "100%",
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            alignSelf: "flex-start",
        },
    },
    ctaBlock: {
        display: "inline-flex",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            alignSelf: "flex-start",
        },
        "& .MuiButton-startIcon > *:nth-of-type(1)": {
            fontSize: "18px !important",
        },
    },
    mobileAddedToBasketWrapper: {
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
    },
    mobileAddedToBasket: {
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(1),
        textAlign: "center",
    },
    checkCircleIcon: {
        width: 17,
        height: 17,
    },
    seeFullTerms: {
        width: "100%",
        textAlign: "center",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP)]: {
            textAlign: "start",
        },
    },
    phoneIcon: {
        height: 30,
        width: 18,
    },
    ellipseIcon: {
        height: 10,
        width: 10,
    },
    warningIcon: {
        color: theme.palette.secondary.main,
    },
}));
